import "../assets/link.scss";
import {LinkExternal} from "./LinkExternal";

/**
 * Компонент ссылки, которая при нажатии будет открываться в новой вкладке.
 * Нужно использовать для внутренних ссылок сайта.
 * 
 * @param {*} props 
 * @returns 
 */
export function LinkBlank(props) {
  const {to, children = []} = props;
  return <LinkExternal to={to}>{children}</LinkExternal>;
}